/* global angular */
/* jshint scripturl:true */
/* jshint -W030 */

var ngModule = angular.module('trends');
ngModule.directive('lockdownHandler', ['$window', function ($window) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var frameset_required = function () {
                    try {
                        return $window.self === $window.top ||
                            $window.location.host !== $window.parent.location.host;
                    } catch(e) {
                        return true;
                    }
                };

                var lockdown = parseInt(attrs.lockdownHandler);
                if (lockdown) {
                    element.attr('onload', 'javascript:enable_links()');
                    element.attr('ondragstart', 'return false;');
                    element.attr('onselectstart', 'return false;');
                    element.attr('onkeyup', 'javascript:upkey()');
                    element.attr('onmousemove', 'javascript:mmove()');
                    element.attr('onContextMenu', 'return false');

                    if (frameset_required()) {
                        top.location.href = '/trends/?l' + $window.location.hash;
                    }
                }
            }
        };
}]).run(['$rootScope', '$window', function($rootScope, $window) {
    // pseudo-hack to make framesets function properly with angular,
    // if the frame has a parent window then adopt its hash on startup and push
    // history state to window scope on change (no reloading)

    // check if the parent is accessable, if not then don't bother with the rest
    try {
        $window.parent.document;
    }catch(e) {
        return;
    }

    // ensures that refreshes work properly
    $window.location.hash = top.location.hash;

    // whenever the hash of the frame document changes update the url of the
    // parent root frame.
    $rootScope.$watch(function() {
        return location.hash;
    }, function(value) {
        if (top.history && top.history.replaceState && top.location.hash !== value) {
            top.history.replaceState(null, null, value);
        }
    });
}]);
